export const irArriba = () => {
    window.scroll(0,0)
}